export type { Row, MemoryStore as Store } from '../memory-store';

/** Not a security property in the demo: only a stable label for a file. */
export function sha256Hex(bytes: Uint8Array): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < bytes.length; i += 1) h = Math.imul(h ^ bytes[i]!, 0x01000193) >>> 0;
  return h.toString(16).padStart(8, '0').repeat(8);
}
